export default "__VITE_ASSET__Dtcuxwro__"